import { UserBody } from '../types/UsersBody';
import { dashboardService } from '../services/dashboardService';
import { DashboardActions } from '../types/DashboardAction';



const getReviewees = () => (dispatch: any) => {
    const success = (data: UserBody[]): DashboardActions => ({ type: 'REVIEWEES', data });
    dashboardService.myReviewees().then((res: any) => { dispatch(success(res)) })
}

const setHasMylibraryQueue = (payload: boolean, dispatch: any) => {
    const success = (data: boolean): DashboardActions => ({ type: 'HAS_MY_LIBRARY_QUEUE', data });
    dispatch(success(payload))
  }


export {
    getReviewees,
    setHasMylibraryQueue
}